import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Container, Row, Form } from "react-bootstrap";
import "../../../assets/styles/dashboard.scss";

const QuickSearch = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    terminalEx: "",
    terminalDr: "",
    dayOfWeek: "",
    routeType: "",
    routeNumber: "",
    streetName: "",
    postcode: "",
    cityName: "",
  });

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const formatPostcode = (value) => {
    const digits = String(value ?? "")
      .replace(/\D/g, "")
      .slice(0, 5);
    return digits.length > 2
      ? `${digits.slice(0, 2)}-${digits.slice(2)}`
      : digits;
  };

  const handleSearch = () => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value.trim() !== "") {
        params.append(key, value);
      }
    });

    navigate(`/addresses?${params.toString()}`);
  };

  const handleClear = () => {
    setFilters({
      terminalEx: "",
      terminalDr: "",
      dayOfWeek: "",
      routeType: "",
      routeNumber: "",
      streetName: "",
      postcode: "",
      cityName: "",
    });
  };

  return (
    <div className="routes-list-container">
      <Container fluid>
        <Row className="align-items-center mb-4">
          <h4>Szybkie wyszukiwanie</h4>
        </Row>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <Row className="g-4">
          <Col md={6}>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-5 pe">
                <Form.Label>Terminal EX</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="EX"
                  value={filters.terminalEx}
                  onChange={(e) =>
                    handleFilterChange("terminalEx", e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>Terminal DR</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="DR"
                  value={filters.terminalDr}
                  onChange={(e) =>
                    handleFilterChange("terminalDr", e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>Dzień tygodnia</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Select
                  value={filters.dayOfWeek}
                  onChange={(e) =>
                    handleFilterChange("dayOfWeek", e.target.value)
                  }
                >
                  <option value="">--Wybierz--</option>
                  <option value="PN">Poniedziałek</option>
                  <option value="WT">Wtorek</option>
                  <option value="SR">Środa</option>
                  <option value="CZ">Czwartek</option>
                  <option value="PT">Piątek</option>
                  <option value="SB">Sobota</option>
                </Form.Select>
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>Trasa</Form.Label>
              </Col>
              <Col xs={12} sm={3} md={3}>
                <Form.Select
                  value={filters.routeType}
                  onChange={(e) =>
                    handleFilterChange("routeType", e.target.value)
                  }
                >
                  <option value="">----</option>
                  <option value="EX">EX</option>
                  <option value="DR">DR</option>
                  <option value="W">W</option>
                </Form.Select>
              </Col>
              <Col xs={12} sm={4} md={3}>
                <Form.Control
                  type="text"
                  placeholder="Trasa"
                  value={filters.routeNumber}
                  onChange={(e) =>
                    handleFilterChange("routeNumber", e.target.value)
                  }
                />
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>Ulica</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="Ulica"
                  value={filters.streetName}
                  onChange={(e) =>
                    handleFilterChange("streetName", e.target.value)
                  }
                />
              </Col>
            </Row>{" "}
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>Kod pocztowy</Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="__-___"
                  inputMode="numeric"
                  value={filters.postcode || ""}
                  onChange={(e) =>
                    handleFilterChange("postcode", formatPostcode(e.target.value))
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2 align-items-center g-3">
              <Col xs={12} sm={5} md={4} className="pe-sm-4">
                <Form.Label>
                  Miejscowość
                </Form.Label>
              </Col>
              <Col xs={12} sm={7} md={8}>
                <Form.Control
                  type="text"
                  placeholder="Miejscowość"
                  value={filters.cityName}
                  onChange={(e) =>
                    handleFilterChange("cityName", e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row className="mb-2">
              <div className="d-flex">
                <Button
                  className="dashboard-optional-button me-2"
                  type="button"
                  onClick={handleClear}
                >
                  Wyczyść
                </Button>
                <Button
                  className="dashboard-only-button"
                  type="submit"
                  onClick={handleSearch}
                >
                  Szukaj
                </Button>
              </div>
            </Row>
          </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};
export default QuickSearch;
